import { Component, OnInit } from '@angular/core';
import {SttTableComponent} from '../../../../../shared/components/stt-table/stt-table.component';
import {DialogService, DynamicDialogRef} from 'primeng/dynamicdialog';
import { TransportUnitDriverModel } from 'src/app/shared/entities/transport-unit-driver.model';
import { TransportUnitDriverAddEditComponent } from '../transport-unit-driver-add-edit/transport-unit-driver-add-edit.component';
import { finalize } from 'rxjs/operators';
import { ConfirmationService, MessageService, PrimeNGConfig } from 'primeng/api';
import { ValidationMessageService } from '../../../../../shared/services/base/validation-message-handle';
import { TransportUnitDriverService } from '../../../../../shared/services/app/transport-unit-driver.service';

@Component({
  selector: 'app-transport-unit-driver-action-table',
  templateUrl: './transport-unit-driver-action-table.component.html',
  styleUrls: ['./transport-unit-driver-action-table.component.scss']
})
export class TransportUnitDriverActionTableComponent implements OnInit {

  public data: TransportUnitDriverModel;
  public table: SttTableComponent;
  public ref: DynamicDialogRef;
  public loading = true;

  constructor(
      public dialogService: DialogService,
      public confirmationService: ConfirmationService,
      public primengConfig: PrimeNGConfig,
      public itemService: TransportUnitDriverService,
      public messageService: MessageService,
      private validationMessageService: ValidationMessageService,
  ) {

  }

  ngOnInit(): void {
  }

  setParams(entity: TransportUnitDriverModel): void {
      this.data = entity;
  }

  setTableReference(table: SttTableComponent): void
  {
      this.table = table;
  }


  showDialog() {
      this.ref = this.dialogService.open(TransportUnitDriverAddEditComponent, {
          header: 'Modificare sofer unitate transport',
          width: '70%',
          contentStyle: {'max-height': '70vh'},
          baseZIndex: 10000,
          closeOnEscape: false,
          data: this.data,
      });

      this.ref.onClose.subscribe((item: TransportUnitDriverModel) => {
          if (item) {
              this.table.refresh();
          }
      });
  }

    confirm() {
        this.confirmationService.confirm({
            header: 'Confirmare stergere Sofer',
            message: 'Sunteti sigur ca doriti sa stergeti acest sofer?',
            key: 'deleteTransportUnitDriver',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Da',
            rejectLabel: 'Nu',
            acceptButtonStyleClass: 'p-button-md p-button-success',
            rejectButtonStyleClass: 'p-button-md p-button-danger',
            accept: () => {
                this.deleteItem(this.data.uid);
            },
            reject: () => {
                this.confirmationService.close();
                this.table.refresh();
            }
        });
    }

    deleteItem(uid: string){
        this.itemService.delete(uid)
            .pipe(finalize(() => {this.loading = false;this.table.refresh();}))
            .subscribe((response: any) => {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Soferul a fost sters cu success!'
                });
            });
    }
}
